import Tag from '../components/Tag';
import { KPIS } from '../lib/dna';

const arrow = (t: string) => (t === 'up' ? '▲' : t === 'down' ? '▼' : '•');

export default function Kpis() {
  const onTarget = KPIS.filter((k) => k.good).length;
  return (
    <>
      <div className="page-head">
        <div>
          <div className="page-title">KPI Dashboard</div>
          <div className="page-sub">Chapter 15 KPI framework — one measure per department, with target and trend.</div>
        </div>
        <span className="live-flag">{onTarget}/{KPIS.length} on target</span>
      </div>

      <div className="grid cols-4" style={{ marginBottom: 16 }}>
        <div className="metric-card"><div className="metric-label">On Target</div><div className="metric-value" style={{ color: 'var(--gn)' }}>{onTarget}</div><div className="metric-note">of {KPIS.length} KPIs</div></div>
        <div className="metric-card"><div className="metric-label">At Risk</div><div className="metric-value" style={{ color: 'var(--rd)' }}>{KPIS.length - onTarget}</div><div className="metric-note">below target</div></div>
        <div className="metric-card"><div className="metric-label">Departments</div><div className="metric-value" style={{ color: 'var(--ac)' }}>{new Set(KPIS.map((k) => k.dept)).size}</div><div className="metric-note">measured areas</div></div>
        <div className="metric-card"><div className="metric-label">Source</div><div className="metric-value" style={{ fontSize: 16 }}>DNA Ch.15</div><div className="metric-note">representative values</div></div>
      </div>

      <div className="kpi-board">
        {KPIS.map((k) => (
          <div className={`kpi-tile${k.good ? '' : ' risk'}`} key={k.area}>
            <div className="kpi-tile-head">
              <Tag kind="dp" value={k.dept} />
              <span className={`kpi-trend ${k.good ? 'up' : 'down'}`}>{arrow(k.trend)}</span>
            </div>
            <div className="kpi-tile-val">{k.value}</div>
            <div className="kpi-tile-name">{k.kpi}</div>
            <div className="kpi-tile-foot"><span>{k.area}</span><span className={k.good ? 'on' : 'off'}>Target {k.target}</span></div>
          </div>
        ))}
      </div>
    </>
  );
}
